import { SVGProps } from 'react';

export const TimerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M1.125 8C1.125 6.17664 1.84933 4.42795 3.13864 3.13864C4.42795 1.84933 6.17664 1.125 8 1.125C9.82336 1.125 11.572 1.84933 12.8614 3.13864C14.1507 4.42795 14.875 6.17664 14.875 8C14.875 9.82336 14.1507 11.572 12.8614 12.8614C11.572 14.1507 9.82336 14.875 8 14.875C6.17664 14.875 4.42795 14.1507 3.13864 12.8614C1.84933 11.572 1.125 9.82336 1.125 8Z"
      stroke="#667180"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M11.1512 4.84863L8 8.00013"
      stroke="#667180"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
